import siteMenu from "./lib/siteMenu";
import heroAnimation from "./lib/heroAnimation";
import programFilters from "./lib/programFilters";
import responsiveEmbeds from "./lib/responsiveEmbeds";

siteMenu();
heroAnimation();
programFilters();
responsiveEmbeds();
